import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {assertNever} from 'util/Types';

export function getProcedureIcon(procedureType: ProcedureType): BenchlingIconName {
  switch (procedureType) {
    case ProcedureType.RECIPE:
      return 'mortar-pestle';
    case ProcedureType.ASSAY:
      return 'eye-dropper';
    default:
      throw new Error(`Unknown procedure type: ${assertNever(procedureType)}`);
  }
}

export function getProcedureRunIcon(procedureType: ProcedureType): BenchlingIconName {
  switch (procedureType) {
    case ProcedureType.RECIPE:
      return 'mortar-pestle-circle-arrow-right';
    case ProcedureType.ASSAY:
      return 'eye-dropper-circle-arrow-right';
    default:
      throw new Error(`Unknown procedure type: ${assertNever(procedureType)}`);
  }
}
